import { Delay } from "components/atoms/Delay";
import { FreeFortuneFormData } from "features/無料占いBot/hooks/useFreeFortuneForm";
import { useEffect } from "react";

interface Props {
  showAll: boolean;
  eager: boolean;
}

interface UseDebugableReturn {
  defaultFormValues: Pick<
    FreeFortuneFormData,
    | "themeConfirm"
    | "answerConfirm"
    | "birthdayConfirm"
    | "bloodtypeConfirm"
    | "partnerBirthdayConfirm"
    | "nameConfirm"
  >;
  useDebugEffect: (callback: () => void, deps: any[]) => void;
}

const useDebugEffect = (callback: () => void, deps: any[]) => {
  useEffect(callback, [callback, ...deps]);
};

const useDebugable = ({ eager, showAll }: Props): UseDebugableReturn => {
  // NOTE: productionビルドでは何もしない
  const isProduction = process.env.NODE_ENV === "production";

  Delay.eager = !isProduction && eager;

  const isShowAll =
    !isProduction && showAll ? Number(showAll).toString() : undefined;

  const defaultFormValues = {
    themeConfirm: isShowAll,
    answerConfirm: isShowAll,
    birthdayConfirm: isShowAll,
    bloodtypeConfirm: isShowAll,
    partnerBirthdayConfirm: isShowAll,
    nameConfirm: isShowAll,
  };

  return {
    defaultFormValues,
    useDebugEffect,
  };
};

export default useDebugable;
